import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/scanner-activation/create')({
  beforeLoad: () => getTitleContextSlice('Create Scanner Activation'),
});
